import React, { FC } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { Button, Card, Space, Typography } from 'antd';
import { Trans, useTranslation } from 'react-i18next';

import { useDispatchResetReduxState } from '~/pages/login';
import { auth, pushToLogin } from '~/api/axios';
import { useInvitationPageState } from '~/hooks/invitation';
import { useIdentity } from '~/hooks/identity';

const { Title, Text } = Typography;

interface Props extends RouteComponentProps {
  andLogin?: boolean;
}

const TerminateSessionCase: FC<Props> = (props) => {
  const { history, andLogin } = props;
  const { t } = useTranslation('invitation');

  const resetReduxState = useDispatchResetReduxState();
  const [pageState] = useInvitationPageState();
  const currentIdentityQuery = useIdentity();

  const businessName = pageState.data?.businessLegalName;
  const oldEmailOrPhone =
    currentIdentityQuery.data?.emailAddress ||
    currentIdentityQuery.data?.phoneNumber ||
    t('current');
  const newEmail = pageState.data.emailAddress;

  const goAuth = () => {
    if (andLogin) {
      const path = history.location.pathname + history.location.search;
      pushToLogin(path);
    } else {
      auth.deleteToken();
      resetReduxState();
    }
  };

  const handleCancel = () => {
    history.push('/');
  };

  return (
    <Card className="Invitation-Card">
      <Title className="Invitation-Title" level={2}>
        {t('translation:businessPortal').toUpperCase()}
      </Title>
      <Text type="secondary" className="Invitation-TextSignIn">
        <Trans
          ns="invitation"
          i18nKey="invitationFinishWork"
          values={{
            businessName,
            newEmail,
            oldEmailOrPhone,
          }}
        >
          You have been invited to <strong>{{ businessName }}</strong> company as{' '}
          <strong>{{ newEmail }}</strong>. Do you want to finish work with{' '}
          <bdi>
            <strong>{{ oldEmailOrPhone }}</strong>
          </bdi>{' '}
          session and continue enrolment to <strong>{{ businessName }}</strong> company?
        </Trans>
      </Text>
      <Space direction="vertical" style={fullWidth}>
        <Button onClick={goAuth} type="primary" size="large" style={fullWidth}>
          {t('Yes, continue enrolment')}
        </Button>
        <Button onClick={handleCancel} size="large" style={fullWidth}>
          {t("No, I'll enroll later")}
        </Button>
      </Space>
    </Card>
  );
};

const fullWidth = { width: '100%' };

export default TerminateSessionCase;
